import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/tokens.css'
import './styles/app.css'
import './styles/operations.css'
import './styles/agents.css'
import './styles/models.css'

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
